import { render } from "./AdminDashbord.vue?vue&type=template&id=5f84c642"
import script from "./AdminDashbord.vue?vue&type=script&lang=js"
export * from "./AdminDashbord.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__